export default "__VITE_ASSET__emPlDdQx__"